import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([LineChart, GridComponent, TooltipComponent, LegendComponent, CanvasRenderer]);

export const LineChartReport = ({ report = [] }) => {
  const chartRef = useRef(null);
  const [option, setOption] = useState({});

  useEffect(() => {
    if (!report || report.length === 0) return;

    const rootStyles = getComputedStyle(document.body || document.documentElement);
    const primaryColor = rootStyles.getPropertyValue('--color-primary').trim() || '#000000';

    const colors = {
      interface: primaryColor,
      gridLines: '#ECE9F8'
    };

    const optionData = {
      backgroundColor: 'transparent',
      grid: {
        left: '2%',
        right: '5%',
        bottom: '0%',
        top: '10%',
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderWidth: 0,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowBlur: 10,
        textStyle: { color: '#666' }
      },
      xAxis: {
        type: 'category',
        data: report.map(item => item.time),
        boundaryGap: false,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: '#999', fontSize: 11, margin: 30 }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: '{value}h',
          color: '#999',
          fontSize: 11,
          margin: 30
        },
        splitLine: { lineStyle: { color: colors.gridLines } }
      },
      series: [
        {
          name: 'Horas assistidas:',
          type: 'line',
          data: report.map(item => item.interface),
          smooth: false,
          connectNulls: true,
          lineStyle: { width: 2, color: colors.interface },
          itemStyle: { color: colors.interface },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                { offset: 0, color: primaryColor },
                { offset: 1, color: 'rgba(255, 255, 255, 0)' }
              ]
            }
          },
          symbol: 'circle',
          showSymbol: true,
          symbolSize: 10,
          symbolStyle: {
            borderWidth: 2,
            borderColor: colors.interface,
            color: '#00000000'
          }
        }
      ]
    };

    setOption(optionData);
  }, [report]);

  return (
    <ReactECharts
      ref={chartRef}
      option={option}
      echarts={echarts}
      style={{ height: 350, width: '100%' }}
      notMerge={true}
    />
  );
};
